<template>
    <div class="login_container">
        <div class="login_box">
            <!--头像区域-->
            <div class="avatar_box">
                <img src="../assets/1.jpg">
            </div>
            <el-form ref="registerRef1" :model="registerForm" label-width="80px" :rules="registerRules"
                     class="login_form">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="registerForm.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="密保问题" prop="questionId">
                    <el-select  v-model="registerForm.questionId" placeholder="请选择密保问题" style="width: 330px" >
                        <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.question"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="密保答案" prop="questionAnswer">
                    <el-input type="textarea" v-model="registerForm.questionAnswer"
                              placeholder="请输入密保问题"></el-input>
                </el-form-item>
                <el-form-item label="重设密码" prop="password1">
                    <el-input v-model="registerForm.password1" placeholder="请输入新的密码" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="password">
                    <el-input v-model="registerForm.password" placeholder="请再次输入密码" type="password"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="reset">提交</el-button>
                    <el-button @click="toLogin">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Register',
        data() {
            // 自定义校验规则
            const validatePassword = (rule, value, callback) => {
                if (this.registerForm.password1 !== this.registerForm.password) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            return {
                options:[],
                registerForm: {},
                registerRules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 5 个字符', trigger: 'blur'}
                    ],
                    password1: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 15 个字符', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 5, max: 15, message: '长度在 5 到 15 个字符', trigger: 'blur'},
                        {validator: validatePassword, trigger: "blur"}
                    ],
                    questionId: [
                        {required: true, message: '请选择密保问题', trigger: 'blur'},
                    ]
                    ,
                    questionAnswer: [
                        {required: true, message: '请输入问题答案', trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            async getList(){
                let {data: res} = await this.$http.post(`/question/selectQuestion`);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.options = res.data;
                console.log(this.menuList)

            },
            reset() {
                this.$refs.registerRef1.validate(async valid => {
                    if (!valid) return;
                    let {data: res} = await this.$http.post('/resetPassword', this.registerForm);
                    if (res.code !== 1) {
                        this.$message.error(res.msg)
                    } else {
                        this.$message.success('重设成功');
                        await this.$router.push('/login')
                    }
                })
            },
            toLogin() {
                this.$router.push('/login')
            }
        }
    }
</script>

<style scoped lang="less">
    .login_container {
        background-color: #2b4b6b;
        height: 100%;
    }

    .login_box {
        width: 450px;
        height: 480px;
        background-color: #fff;
        border-radius: 3px;
        position: absolute;
        left: 50%;
        top: 55%;
        transform: translate(-50%, -50%);

        .avatar_box {
            height: 130px;
            width: 130px;
            border: 1px solid #eee;
            border-radius: 50%;
            padding: 10px;
            box-shadow: 0 0 10px #ddd;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fff;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background-color: #eee;
            }
        }
    }

    .btns {
        display: flex;
        justify-content: flex-end;
    }

    .login_form {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }
</style>
